import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import { can, ROUTE_FEATURE_MAP } from '../utils/permissions';

const ProtectedRoute = ({ children, feature: featureProp }) => {
  const { isAuthenticated, loading, token, user } = useAuth();
  const location = useLocation();

  const featureKey =
    featureProp || ROUTE_FEATURE_MAP[location.pathname] || null;

  useEffect(() => {
    const getCookie = (name) => {
      const nameEQ = `${name}=`;
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
          try {
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
          } catch {
            return c.substring(nameEQ.length, c.length);
          }
        }
      }
      return null;
    };

    const adminToken = getCookie('adminToken');
    if (!adminToken && !loading) {
      window.location.href = '/login';
    }
  }, [loading]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress size={60} sx={{ color: '#FF7700' }} />
      </Box>
    );
  }

  if (!isAuthenticated || !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Superadmin-only pages (never trust features.includes for these)
  if (
    (featureKey === 'manage_admin_users' || featureKey === 'ivr_admin') &&
    !user?.is_superadmin
  ) {
    return <Navigate to="/" replace state={{ forbidden: featureKey }} />;
  }

  if (featureKey && !can(user, featureKey)) {
    return <Navigate to="/" replace state={{ forbidden: featureKey }} />;
  }

  return children;
};

export default ProtectedRoute;
